import {storeInstance} from '@aofl/store/dist/legacy';
import {isNotQualified} from '@aoflmkt/is-webp-qualified';
import {sdoNamespaces} from '../../../../../../../modules/constants-enumerate';

const img0 = isNotQualified ? '/assets/routes/home/carousel-0-v2.png' : '/assets/routes/home/carousel-0-v2.webp';
const img1 = isNotQualified ? '/assets/routes/home/carousel-1-v2.png' : '/assets/routes/home/carousel-1-v2.webp';
const img2 = isNotQualified ? '/assets/routes/home/carousel-2-v2.png' : '/assets/routes/home/carousel-2-v2.webp';
const img3 = isNotQualified ? '/assets/routes/home/carousel-3-v2.png' : '/assets/routes/home/carousel-3-v2.webp';
const img4 = isNotQualified ? '/assets/routes/home/carousel-4-v2.png' : '/assets/routes/home/carousel-4-v2.webp';
const img5 = isNotQualified ? '/assets/routes/home/carousel-5-v2.png' : '/assets/routes/home/carousel-5-v2.webp';
const img6 = isNotQualified ? '/assets/routes/home/carousel-6-v2.png' : '/assets/routes/home/carousel-6-v2.webp';
const img7 = isNotQualified ? '/assets/routes/home/carousel-7-v2.png' : '/assets/routes/home/carousel-7-v2.webp';

const carouselImages = [
  img0,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7
];

const sdo = {
  namespace: sdoNamespaces.HOME_CAROUSEL,
  mutations: {
    init() {
      return {
        position0: 0,
        position1: 1,
        position2: 2,
        position3: 3,
        position4: 4,
        position5: 5,
        image0: carouselImages[0],
        image1: carouselImages[1],
        image2: carouselImages[2],
        image3: carouselImages[3],
        image4: carouselImages[4],
        image5: carouselImages[5],
        currentImage: carouselImages[0],
        currentImagePosition: 0
      };
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    updateCurrentImage(subState, payload) {
      const {src, position} = payload;
      return Object.assign({}, subState, {currentImage: src, currentImagePosition: position});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    increasePosition0(subState) {
      const newPosition = subState.position0 + 1;
      const newSource = carouselImages[newPosition];
      let result = '';

      if (!newSource) {
        result = Object.assign({}, subState, {position0: 0, image0: carouselImages[0]});
      } else {
        result = Object.assign({}, subState, {position0: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideRightImage0(subState) {
      const newPosition = subState.position0;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image0: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    increasePosition1(subState) {
      const newPosition = subState.position1 + 1;
      const newSource = carouselImages[newPosition];
      let result = '';

      if (!newSource) {
        result = Object.assign({}, subState, {position1: 0, image1: carouselImages[0]});
      } else {
        result = Object.assign({}, subState, {position1: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideRightImage1(subState) {
      const newPosition = subState.position1;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image1: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    increasePosition2(subState) {
      const newPosition = subState.position2 + 1;
      const newSource = carouselImages[newPosition];
      let result = '';

      if (!newSource) {
        result = Object.assign({}, subState, {position2: 0, image2: carouselImages[0]});
      } else {
        result = Object.assign({}, subState, {position2: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideRightImage2(subState) {
      const newPosition = subState.position2;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image2: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    increasePosition3(subState) {
      const newPosition = subState.position3 + 1;
      const newSource = carouselImages[newPosition];
      let result = '';

      if (!newSource) {
        result = Object.assign({}, subState, {position3: 0, image3: carouselImages[0]});
      } else {
        result = Object.assign({}, subState, {position3: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideRightImage3(subState) {
      const newPosition = subState.position3;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image3: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    increasePosition4(subState) {
      const newPosition = subState.position4 + 1;
      const newSource = carouselImages[newPosition];
      let result = '';

      if (!newSource) {
        result = Object.assign({}, subState, {position4: 0, image4: carouselImages[0]});
      } else {
        result = Object.assign({}, subState, {position4: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideRightImage4(subState) {
      const newPosition = subState.position4;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image4: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    increasePosition5(subState) {
      const newPosition = subState.position5 + 1;
      const newSource = carouselImages[newPosition];
      let result = '';

      if (!newSource) {
        result = Object.assign({}, subState, {position5: 0, image5: carouselImages[0]});
      } else {
        result = Object.assign({}, subState, {position5: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideRightImage5(subState) {
      const newPosition = subState.position5;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image5: newSource});
    },

    // LEFT:


    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    decreasePosition0(subState) {
      const newPosition = subState.position0 - 1;
      const newSource = carouselImages[newPosition];
      let result;

      if (!newSource) {
        result = Object.assign(
          {}, subState, {position0: carouselImages.length - 1, image0: carouselImages[carouselImages.length - 1]}
        );
      } else {
        result = Object.assign({}, subState, {position0: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideLeftImage0(subState) {
      const newPosition = subState.position1;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image0: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    decreasePosition1(subState) {
      const newPosition = subState.position1 - 1;
      const newSource = carouselImages[newPosition];
      let result;

      if (!newSource) {
        result = Object.assign(
          {}, subState, {position1: carouselImages.length - 1, image1: carouselImages[carouselImages.length - 1]}
        );
      } else {
        result = Object.assign({}, subState, {position1: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideLeftImage1(subState) {
      const newPosition = subState.position1;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image1: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    decreasePosition2(subState) {
      const newPosition = subState.position2 - 1;
      const newSource = carouselImages[newPosition];
      let result;

      if (!newSource) {
        result = Object.assign(
          {}, subState, {position2: carouselImages.length - 1, image2: carouselImages[carouselImages.length - 1]}
        );
      } else {
        result = Object.assign({}, subState, {position2: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideLeftImage2(subState) {
      const newPosition = subState.position2;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image2: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    decreasePosition3(subState) {
      const newPosition = subState.position3 - 1;
      const newSource = carouselImages[newPosition];
      let result;

      if (!newSource) {
        result = Object.assign(
          {}, subState, {position3: carouselImages.length - 1, image3: carouselImages[carouselImages.length - 1]}
        );
      } else {
        result = Object.assign({}, subState, {position3: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideLeftImage3(subState) {
      const newPosition = subState.position3;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image3: newSource});
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    decreasePosition4(subState) {
      const newPosition = subState.position4 - 1;
      const newSource = carouselImages[newPosition];
      let result;

      if (!newSource) {
        result = Object.assign(
          {}, subState, {position4: carouselImages.length - 1, image4: carouselImages[carouselImages.length - 1]}
        );
      } else {
        result = Object.assign({}, subState, {position4: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideLeftImage4(subState) {
      const newPosition = subState.position4;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image4: newSource});
    },


    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    decreasePosition5(subState) {
      const newPosition = subState.position5 - 1;
      const newSource = carouselImages[newPosition];
      let result;

      if (!newSource) {
        result = Object.assign(
          {}, subState, {position5: carouselImages.length - 1, image5: carouselImages[carouselImages.length - 1]}
        );
      } else {
        result = Object.assign({}, subState, {position5: newPosition});
      }
      return result;
    },

    /**
     *
     * @param {*} subState
     * @return {Object}
     */
    slideLeftImage5(subState) {
      const newPosition = subState.position5;
      const newSource = carouselImages[newPosition];
      return Object.assign({}, subState, {image5: newSource});
    }
  }
};

storeInstance.addState(sdo);
